export default __webpack_public_path__ + "static/media/download_img.76197fd1.svg";